import { render, staticRenderFns } from "./clientProfileManageTpColumn.vue?vue&type=template&id=103598ac&scoped=true"
import script from "./clientProfileManageTpColumn.vue?vue&type=script&lang=js"
export * from "./clientProfileManageTpColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103598ac",
  null
  
)

export default component.exports